import ViewProtocolModal from './ViewProtocolDefinition'
import ViewAnalytesModal from './ViewAnalyteDefinition'

export { ViewProtocolModal, ViewAnalytesModal }

export const MODALS = {
  viewProtocol: ViewProtocolModal,
  viewAnalytes: ViewAnalytesModal
}
